/* global requirejs */
define(function (require) {
	const MapView = require('civicsViews/agencymap_view/v_agencymap');
  const ViewManager = require('civicsUtils/view_manager');

	return MapView.extend({
		initialize: function (options) {
			this.config = [];
			this.regionId = options.config.regionId != null ? options.config.regionId + ' gis-map-region': 'gis-map-region';
			this.config.globalConfig = ViewManager.globalConfig();

			this.mapReady = false;//used to determine what to do for destroying this view
			// nothing to do?
			var self = this;
			let radio = options.config.channel;
			if ( radio ){
				radio.on('map:ready', info => {
						if(typeof self.ui.mapLoader == 'string') {
					    	$(self.ui.mapLoader).hide();
						} else {
							self.ui.mapLoader.hide();
						}

						if( __DEV__ ) console.log('map:ready', info);
                        self.mapReady = true;
						
						if ($('.rhythm-civics-base').length > 1) {
							$('.rhythm-civics-base').last().remove();
						}

						$('.maplet-region input[type="text"]')
							.attr('id', 'search_address_textbox');
				});
			}
		},
		onBeforeDestroy: function () {
			// be explicit about killing the maplet
			var self = this;
			let radio = this.options.config.channel;
			if (radio) {
				radio.off('map:ready');
				radio.trigger("map:destroy");
			}
			
			$(document).find("." + self.regionId).children().remove();
		}
	});
});
